import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DriftBotInboxService {

  constructor(private http: HttpClient) { }

  createDriftBotInbox(name: string, emailAddress: string): Observable<any> {
    return this.http
    .post(`/api/v1/drift_bot_inbox`,
    JSON.stringify({ name, emailAddress }));
  }
}


// WEBPACK FOOTER //
// ./client/app/services/drift-bot-inbox.service.ts